import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import { normalizeSupportedLanguage } from '../utils/createScopedI18n';

export default function useScopedTranslation(i18nInstance) {
  const { language } = useLanguage();
  const normalizedLanguage = normalizeSupportedLanguage(language);

  if (i18nInstance.language !== normalizedLanguage) {
    i18nInstance.changeLanguage(normalizedLanguage);
  }

  const { t } = useTranslation(undefined, { i18n: i18nInstance });

  return { t, language: normalizedLanguage };
}
